import { render } from "./CustomFieldsTable.vue?vue&type=template&id=947a2416&scoped=true"
import script from "./CustomFieldsTable.vue?vue&type=script&lang=js"
export * from "./CustomFieldsTable.vue?vue&type=script&lang=js"

import "./CustomFieldsTable.vue?vue&type=style&index=0&id=947a2416&lang=scss&scoped=true"
import "./CustomFieldsTable.vue?vue&type=style&index=1&id=947a2416&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947a2416"]])

export default __exports__